import styled from 'styled-components';
import { BodyText } from '../../../ui-toolkit';

export const SecondaryText = styled(BodyText)`
  color: ${(props) => props.theme.colors.secondary};
`;
